import React, { useEffect, useRef } from 'react';

import './PaperlessTerms.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getPaperlessTermsAndConditions } from '../../../redux/modules/paperless/paperlessSetting.module';
import Loader from '../../../components/Loader/Loader';

const PaperlessTerms = ({ closeModal }) => {
  const dispatch = useDispatch();
  const { termsAndConditions, isLoading } = useSelector(
    (state) => state.paperlessSetting
  );
  const myRef = useRef();

  useEffect(() => {
    try {
      if (!termsAndConditions) {
        const getTermsData = () => {
          dispatch(getPaperlessTermsAndConditions());
        };
        getTermsData();
      } else {
        myRef.current.innerHTML = termsAndConditions;
      }
    } catch (e) {
      console.log(e);
    }
  }, [dispatch, termsAndConditions, myRef]);
  if (isLoading) return <Loader isVisible={true} />;
  return (
    <div className="paperless-terms-container" id="e2e-paperless-terms">
      <section ref={myRef}> </section>
    </div>
  );
};
export default PaperlessTerms;
